function SvgMessaging(props) {
  return (
    <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <defs>
        <path d="M0 .021h23.82V6.83H0z" id="messaging_svg__a" />
        <path d="M0 .125h23.82v6.808H0z" id="messaging_svg__c" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 1)">
          <mask fill="#fff" id="messaging_svg__b">
            <use xlinkHref="#messaging_svg__a" />
          </mask>
          <path
            d="M1.342 1.008a.348.348 0 00-.34.356v4.123c0 .196.153.355.34.355h21.136c.187 0 .339-.159.339-.355V1.363a.348.348 0 00-.34-.355H1.343zm21.136 5.821H1.342C.602 6.83 0 6.227 0 5.487V1.364C0 .624.602.02 1.342.02h21.136c.74 0 1.342.602 1.342 1.342v4.124c0 .74-.602 1.342-1.342 1.342z"
            fill="currentColor"
            mask="url(#messaging_svg__b)"
          />
        </g>
        <path
          d="M20.267 3.133a1.067 1.067 0 110 2.134 1.067 1.067 0 010-2.134"
          fill="currentColor"
        />
        <g transform="translate(0 16.467)">
          <mask fill="#fff" id="messaging_svg__d">
            <use xlinkHref="#messaging_svg__c" />
          </mask>
          <path
            d="M1.342 1.112a.348.348 0 00-.34.355V5.59c0 .197.153.356.34.356h21.136c.187 0 .339-.16.339-.356V1.467a.348.348 0 00-.34-.355H1.343zm21.136 5.821H1.342C.602 6.933 0 6.331 0 5.59V1.467C0 .727.602.125 1.342.125h21.136c.74 0 1.342.602 1.342 1.342V5.59c0 .741-.602 1.343-1.342 1.343z"
            fill="currentColor"
            mask="url(#messaging_svg__d)"
          />
        </g>
        <path
          d="M20.267 19.133a1.067 1.067 0 110 2.134 1.067 1.067 0 010-2.134M1.342 9.472c-.189 0-.342.162-.342.362v4.199c0 .2.153.362.342.362h21.316c.189 0 .342-.162.342-.362v-4.2c0-.199-.153-.361-.342-.361H1.342zM22.648 15.4H1.352A1.361 1.361 0 010 14.033v-4.2c0-.753.606-1.366 1.352-1.366h21.296c.745 0 1.352.613 1.352 1.367v4.199c0 .754-.607 1.367-1.352 1.367z"
          fill="currentColor"
        />
        <path
          d="M20.267 11.133a1.067 1.067 0 110 2.134 1.067 1.067 0 010-2.134"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default SvgMessaging
